import { data } from "react-router-dom";

export const formatNumber = (number) => {
  const roundedNumber = number.toFixed(2);
  return parseFloat(roundedNumber).toLocaleString("en-US", {
    style: "decimal",
    maximumFractionDigits: 2,
  });
};

export const totalSum = (data) => {
  return data
    .map((item) => item.revenue_income)
    .reduce((acc, curr) => acc + curr, 0);
};

export const renameKeys = (data) => {
  if (!Array.isArray(data)) {
    console.error("renameKeys: data is not an array or is undefined", data);
    return [];
  }
  return data.map((item) => ({
    month: item.year_month,
    revenue: item.revenue_income,
  }));
};

export const renameKeysCost = (data) => {
  if (!Array.isArray(data)) {
    console.error("renameKeys: data is not an array or is undefined", data);
    return [];
  }
  return data.map((item) => ({
    month: item.year_month,
    revenue: item.goods_sold_cost,
  }));
};

export const sumByRegion = (data) => {
  if (!Array.isArray(data)) {
    console.error("Invalid data: Expected an array but got", data);
    return {};
  }
  return data.reduce((acc, item) => {
    acc[item.regional] = (acc[item.regional] || 0) + item.revenue_income;
    return acc;
  }, {});
};

export const formattedDataRemoveNone = Object.entries(data)
  .map(([region, totalRevenue]) => ({
    name: region,
    value: totalRevenue,
  }))
  .filter((item) => item.name !== "(None)")
  .sort((a, b) => b.value - a.value);

export const transformRevenueData = (data, categoryPath) => {
  // Extract categories based on the path
  let categories;

  if (categoryPath) {
    // Navigate through the object using the path
    categories = categoryPath
      .split(".")
      .reduce(
        (obj, key) => (obj && obj[key] !== undefined ? obj[key] : null),
        data
      );
  } else {
    // If no path is provided, assume data is already the categories array
    categories = data;
  }

  if (!Array.isArray(categories)) return [];

  // Rest of your function remains the same
  // Get unique months
  const uniqueMonths = [
    ...new Set(categories.map((item) => item.year_month)),
  ].sort();

  // Check if we have at least two months of data
  if (uniqueMonths.length < 2)
    return categories.map((item) => ({
      account_dashboard_rename: item.account_dashboard_rename,
      revenue_income: item.revenue_income,
      revenue_income_lastmonth: 0,
      percentChange: null,
    }));

  const latestMonth = uniqueMonths[uniqueMonths.length - 1];
  const previousMonth = uniqueMonths[uniqueMonths.length - 2];

  // Map of previous month's data
  const lastMonthMap = {};
  categories.forEach((item) => {
    if (item.year_month === previousMonth) {
      lastMonthMap[item.account_dashboard_rename] = item.revenue_income;
    }
  });

  const currentMap = new Map();

  // Step 1: Add current month items
  categories
    .filter((item) => item.year_month === latestMonth)
    .forEach((item) => {
      const lastRevenue = lastMonthMap[item.account_dashboard_rename] || 0;
      currentMap.set(item.account_dashboard_rename, {
        account_dashboard_rename: item.account_dashboard_rename,
        revenue_income: item.revenue_income,
        revenue_income_lastmonth: lastRevenue,
        percentChange:
          lastRevenue !== 0
            ? ((item.revenue_income - lastRevenue) / lastRevenue) * 100
            : 100,
      });
    });

  // Step 2: Add missing from current but present last month
  Object.keys(lastMonthMap).forEach((name) => {
    if (!currentMap.has(name)) {
      const lastRevenue = lastMonthMap[name];
      currentMap.set(name, {
        account_dashboard_rename: name,
        revenue_income: 0,
        revenue_income_lastmonth: lastRevenue,
        percentChange: -100,
      });
    }
  });

  // Step 3: Remove items where both revenue = 0
  const transformed = Array.from(currentMap.values()).filter(
    (item) =>
      !(item.revenue_income === 0 && item.revenue_income_lastmonth === 0)
  );

  return transformed;
};
